// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1_rT4","disabled":"FileBtn_disabled__o83if","warn":"FileBtn_warn__5kGjE","fade":"FileBtn_fade__2jIx5"};